import React from "react";
import Manutencao from "../../src/components/Helper/Manutencao/Manutencao";
import Header from "../../src/components/Header/Header";
import Footer from "../../src/components/Footer/Footer";
import Head from "next/head";
import Title from "../../src/components/Title/Title";
import styles from "./Certificacoes.module.css";
import iso from "../../src/assets/certificacoes/certIso.jpg";
import fsc from "../../src/assets/certificacoes/certFsc.jpg";
import Image from "next/future/image";

const Certificacoes = () => {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Salinas, salinas, salinas embalagem, cartonagem, embalagem, cartonagem salinas, empresa Salinas, embalagem personalizada, embalagem papelao, salinas pederneiras, salinas sp"
        />
        <meta httpEquiv="Cache-Control" content="max-age=604800" />
        <meta name="description" content="Salinas embalagem" />
        <meta name="title" content="Certificações | Cartonagem Salinas" />
        <title>Certificações | Cartonagem Salinas</title>
        <meta name="copyright" content="© 2022 Salinas Embalagem" />
      </Head>
      <Header />
      <Title title="Certificações" />
      <section className={styles.certificacoes}>
        <div className=" container-main">
          <ul>
            <li>
              <div className={styles.content}>
                <div className={styles.imgGroup}>
                  <Image src={iso} width={242} height={217} alt="iso" />
                </div>
                <div>
                  <p>
                    As normas da <strong>ISO 9001:2015</strong> foram elaboradas
                    por meio de um consenso internacional acerca das práticas
                    que uma empresa deve tomar a fim de atender plenamente os
                    requisitos de qualidade. A Salinas Embalagem possui
                    certificação <strong>ISO 9001</strong> , o que garante a
                    qualidade de nossos processos, pois realizamos o
                    monitoramento de desempenho através de auditorias internas e
                    externas periódicas.
                  </p>
                  <p>
                    {" "}
                    Para manter a certificação, diversos requisitos devem ser
                    atendidos. Podendo destacar: A padronização, o monitoramento
                    da matéria prima, realização de pesquisas periódicas com os
                    clientes, rastreabilidade de toda cadeia produtiva, e um
                    cronograma de treinamento para garantir a qualificação e o
                    desempenho de nossos colaboradores.
                  </p>
                  <p>
                    A{" "}
                    <strong>
                      IQNet (The International Certification Network)
                    </strong>{" "}
                    foi criada em 1990. Sediada na Suíça, é uma rede
                    internacional de entidades certificadoras. Com o certificado
                    IQNet a Salinas Embalagem obtém reconhecimento e valorização
                    no mercado internacional.
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.content}>
                <div>
                  <Image src={fsc} width={208} height={138} alt="fsc" />
                </div>
                <div>
                  <p>
                    A <strong>Forest Stewardship Council ®( FSC®)</strong> é uma
                    organização não governamental e sem fins lucrativos que tem
                    a missão de promover o manejo responsável das florestas do
                    mundo. A Salinas Embalagem é certificada com o selo
                    FSC®cadeia de custódia (COC), ou seja, adquire sua
                    matéria-prima de produtores que processam a matéria-prima de
                    florestas certificadas, garantindo a rastreabilidade de toda
                    a cadeia produtiva. A Salinas Embalagem declara que não está
                    direta ou indiretamente envolvida nas seguintes atividades:
                    Dentro dos itens citados abaixo da frase acima:
                  </p>
                  <ul>
                    <li>
                      Corte de madeira ilegal ou comércio ilegal de produtos
                      florestais ou madeireiros;
                    </li>
                    <li>
                      Violação de direitos tradicionais e humanos em operações
                      florestais;
                    </li>
                    <li>
                      Destruição de atributos de alto valor para conservação em
                      operações florestais;
                    </li>
                    <li>
                      Conversão significativa de florestas em plantações ou uso
                      não florestal;
                    </li>
                    <li>
                      Introdução de organismos geneticamente modificados em
                      operações florestais;
                    </li>
                    <li>
                      {" "}
                      Violação de qualquer uma das Convenções da OIT (ILO Core
                      Conventions) conforme definido na Declaração da OIT sobre
                      Princípios e Direitos Fundamentais no Trabalho, 1998.
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Certificacoes;
